import React, { useEffect, useRef, useState } from 'react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import { useInterval } from 'react-use';
import 'react-circular-progressbar/dist/styles.css';
import './Goal.scss';
const _getColorAndDescription = (percentage, goal) => {
  let description = 'Fair';
  let colorProgress = '#FF3D50';
  if (percentage >= goal) {
    description = 'Good';
    colorProgress = '#5ACB30';
  }
  return {
    description,
    colorProgress
  };
};
export default function Goal({
  percentage,
  goal,
  body_font_family,
  body_color,
  playing
}) {
  const oldValue = useRef(0);
  const [value, setValue] = useState(oldValue.current);
  useInterval(() => {
    playing && setValue(val => {
      if (val >= percentage) {
        oldValue.current = percentage;
        return val;
      }
      return val + 1;
    });
  }, value < percentage ? 50 : null);
  const {
    description,
    colorProgress
  } = _getColorAndDescription(value, goal);
  useEffect(() => {
    if (!playing) setValue(0);
  }, [playing]);
  return /*#__PURE__*/React.createElement("div", {
    className: "loyalty-gauge-goal-progress-container",
    style: {
      fontFamily: body_font_family,
      color: body_color
    }
  }, /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    strokeWidth: 5,
    value: value || 1,
    circleRatio: 0.50,
    styles: {
      // Customize the root svg element
      root: {
        width: 1000
      },
      // Customize the path, i.e. the "completed progress"
      path: {
        // Path color
        stroke: colorProgress,
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: 'round',
        // Customize transition animation
        transition: 'stroke-dashoffset 0s ease 0s',
        // Rotate the path
        transform: 'rotate(0.75turn)',
        transformOrigin: 'center center'
      },
      // Customize the circle behind the path, i.e. the "total progress"
      trail: {
        // Trail color
        stroke: '#969696',
        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
        strokeLinecap: 'round',
        // Rotate the trail
        transform: 'rotate(0.75turn)',
        transformOrigin: 'center center'
      },
      // Customize the text
      text: {
        // Text color
        fill: 'blue',
        // Text size
        fontSize: '21px',
        fontWeight: 'bold'
      },
      // Customize background - only used when the `background` prop is true
      background: {
        fill: '#969696'
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "description-progress"
  }, description), /*#__PURE__*/React.createElement("div", {
    className: "percentage-progress"
  }, /*#__PURE__*/React.createElement("div", null, value), /*#__PURE__*/React.createElement("div", {
    className: "percentage-symbol"
  }, "%"))));
}